import map from 'lodash/map';
import { ALPHABET, IMPORT_LETTERS } from '../constants';

const initialState = ALPHABET.map(letter => ({ letter }));

const mapLetter = item => ({
  letter: item.letter,
  enabled: item.customers > 0,
});

function letters(state = initialState, action) {
  switch (action.type) {
    case IMPORT_LETTERS:
      return map(action.payload, mapLetter);
    default:
      return state;
  }
}

export default letters;
